import {filler, fragment} from '@xh/hoist/cmp/layout';
import {hoistCmp, uses} from '@xh/hoist/core';
import {button} from '@xh/hoist/desktop/cmp/button';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {Icon} from '@xh/hoist/icon';
import {dialog} from '@xh/hoist/kit/blueprint';
import './SecurityEditDialog.scss';
import {SecurityEditDialogModel} from './SecurityEditDialogModel';
import {tabContainer} from '@xh/hoist/cmp/tab';
import {tabSwitcher} from '@xh/hoist/desktop/cmp/tab';

export const securityEditDialog = hoistCmp.factory({
    className: 'security-edit-dialog',
    model: uses(SecurityEditDialogModel),
    render({className, model}) {
        return dialog({
            className,
            isOpen: model.isOpen,
            title: model.security?.name ?? 'Add new security',
            icon: model.security ? Icon.edit() : Icon.add(),
            onClose: () => model.close(),
            canEscapeKeyClose: false,
            canOutsideClickClose: false,
            item: fragment(
                panel({
                    tbar: toolbar(tabSwitcher()),
                    item: tabContainer({switcher: false}),
                    bbar: bbar(),
                    mask: model.apiTask
                })
            )
        });
    }
});

const bbar = hoistCmp.factory<SecurityEditDialogModel>(({model}) =>
    toolbar(
        filler(),
        button({
            text: 'Close',
            onClick: () => model.close()
        })
    )
);
